// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IGrossVehicleWeightRatingType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    grossVehicleWeightMinRange: number;
    grossVehicleWeightMaxRange: number;
    sortOrder: number;
    active: boolean;
}

export class GrossVehicleWeightRatingType implements IGrossVehicleWeightRatingType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public grossVehicleWeightMinRange: number;
    public grossVehicleWeightMaxRange: number;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns 0 - 6,000# GrossVehicleWeightRatingType
	**/
    get One(): IGrossVehicleWeightRatingType {
        return this.FromId(1);
    }
    /**
		Returns 6,001 - 10,000 GrossVehicleWeightRatingType
	**/
    get Two(): IGrossVehicleWeightRatingType {
        return this.FromId(2);
    }
    /**
		Returns 10,001 - 14,000 GrossVehicleWeightRatingType
	**/
    get Three(): IGrossVehicleWeightRatingType {
        return this.FromId(3);
    }
    /**
		Returns 14,001 - 16,000 GrossVehicleWeightRatingType
	**/
    get Four(): IGrossVehicleWeightRatingType {
        return this.FromId(4);
    }
    /**
		Returns 16,001 - 19,500 GrossVehicleWeightRatingType
	**/
    get Five(): IGrossVehicleWeightRatingType {
        return this.FromId(5);
    }
    /**
		Returns 19,501 - 26,000 GrossVehicleWeightRatingType
	**/
    get Six(): IGrossVehicleWeightRatingType {
        return this.FromId(6);
    }
    /**
		Returns 26,001 - 33,000 GrossVehicleWeightRatingType
	**/
    get Seven(): IGrossVehicleWeightRatingType {
        return this.FromId(7);
    }
    /**
		Returns 33,000+ GrossVehicleWeightRatingType
	**/
    get Eight(): IGrossVehicleWeightRatingType {
        return this.FromId(8);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: '1', displayValue: '0 - 6,000#', description: '0 - 6,000#', grossVehicleWeightMinRange: 0, grossVehicleWeightMaxRange: 6000, sortOrder: 5, active: true });
        this._dictionary.add('2', { id: 2, value: '2', displayValue: '6,001 - 10,000', description: '6,001 - 10,000', grossVehicleWeightMinRange: 6001, grossVehicleWeightMaxRange: 10000, sortOrder: 10, active: true });
        this._dictionary.add('3', { id: 3, value: '3', displayValue: '10,001 - 14,000', description: '10,001 - 14,000', grossVehicleWeightMinRange: 10001, grossVehicleWeightMaxRange: 14000, sortOrder: 15, active: true });
        this._dictionary.add('4', { id: 4, value: '4', displayValue: '14,001 - 16,000', description: '14,001 - 16,000', grossVehicleWeightMinRange: 14001, grossVehicleWeightMaxRange: 16000, sortOrder: 20, active: true });
        this._dictionary.add('5', { id: 5, value: '5', displayValue: '16,001 - 19,500', description: '16,001 - 19,500', grossVehicleWeightMinRange: 16001, grossVehicleWeightMaxRange: 19500, sortOrder: 25, active: true });
        this._dictionary.add('6', { id: 6, value: '6', displayValue: '19,501 - 26,000', description: '19,501 - 26,000', grossVehicleWeightMinRange: 19051, grossVehicleWeightMaxRange: 26000, sortOrder: 30, active: true });
        this._dictionary.add('7', { id: 7, value: '7', displayValue: '26,001 - 33,000', description: '26,001 - 33,000', grossVehicleWeightMinRange: 26001, grossVehicleWeightMaxRange: 33000, sortOrder: 35, active: true });
        this._dictionary.add('8', { id: 8, value: '8', displayValue: '33,000+', description: '33,000+', grossVehicleWeightMinRange: 33001, grossVehicleWeightMaxRange: 99999, sortOrder: 40, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IGrossVehicleWeightRatingType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IGrossVehicleWeightRatingType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IGrossVehicleWeightRatingType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IGrossVehicleWeightRatingType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IGrossVehicleWeightRatingType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
